import {createSelector} from '@ngrx/store';

import * as fromCitizenServiceSector from './citizens-services-sector.reducer';
import {AppState} from 'src/app/store/reducers';


export const currentState = (state: AppState) => (state[fromCitizenServiceSector.citizensServicesSectorsFeatureKey]);

export const selectAllCitizenSector = createSelector(currentState, fromCitizenServiceSector.selectAll);

export const selectCitizenTotal = createSelector(currentState, fromCitizenServiceSector.selectTotal);

export const selectModifiedCitizenSector = createSelector(selectAllCitizenSector, (sectors) => {
  return sectors.map((sector) => {
    return {
      ...sector
    };
  });
});
